export default "__VITE_ASSET__8BlorkUE__"